import React, { useState, useEffect } from "react";
import { BsChevronCompactLeft, BsChevronCompactRight } from "react-icons/bs";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { RxDotFilled } from "react-icons/rx";
import axios from "axios";
import { FaWifi, FaBath, FaBed } from "react-icons/fa";
// import "../../assets/css/style.css";
// import "../../assets/css/bootstrap.min.css";
import Header from "../../components/UserHeaer.jsx";


function PostDetails() {
  const [autoPlay, setAutoPlay] = useState(true);
  const [post, setPost] = useState(null);
  let timeOut = null;
  const token = localStorage.getItem("Token");
  const location = useLocation();
  const postId = location.state?.postId;
  const navigate = useNavigate();

  const fetchPostData = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `https://trototbe.azurewebsites.net/api/Posts/byId?postId=${postId}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("data", JSON.stringify(response.data));
        setPost(response?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getProfile = (id) => {
    navigate('/profile', { state: { userId: id } });
  }

  useEffect(() => {
    timeOut =
      autoPlay &&
      setTimeout(() => {
        nextSlide();
      }, 2500);
  });

  const slides = [
    {
      url: "https://images.unsplash.com/photo-1605346576608-92f1346b67d6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80",
    },
    {
      url: "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1171&q=80",
    },
    {
      url: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const nextSlide = () => {
    const isLastSlide = currentIndex === slides.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  const goToSlide = (slideIndex) => {
    setCurrentIndex(slideIndex);
  };

  useEffect(() => {
    if (localStorage) {
      var role = localStorage.getItem("Role");
      console.log(role);
      if (role !== "User" && role !== "Vip") {
        navigate("/");
      } else {
        fetchPostData();
      }
    }
  }, []);

  return (
    <div>
      <Header />
      {!post ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            fontSize: "20px",
            fontWeight: "bold",
            color: "#333",
          }}
        >
          Đang tải...
        </div>
      ) : (
        <div>
          <h2 className="text-center font-bold text-2xl mt-10">
            {post?.title}
          </h2>
          <div className="max-w-[1100px] px-4 m-auto text-xl">
            <div className="my-2 flex items-center">
              <span>Người đăng: </span>
              <div onClick={() => getProfile(post?.userId)} class="relative w-10 h-10 text-white transition-all duration-200 border-2
                   border-white border-solid rounded-full ml-5 hover:cursor-pointer">
                <img class="w-full h-full rounded-full" alt="Image placeholder"
                  src={post?.userImage} />
              </div>
              <div onClick={() => getProfile(post?.userId)} className="h-6 px-2 font-bold hover:cursor-pointer">
                {post?.userName}
              </div>
            </div>
            <div className="py-1">Ngày đăng:&nbsp; &nbsp;&nbsp; &nbsp; {post?.dateTimeString}</div>
            <div className="py-1">Loại bài đăng:&nbsp; &nbsp;{post?.categoryName}</div>
            <div className="py-1">Loại phòng:&nbsp; &nbsp;&nbsp; &nbsp; {post?.typeName}</div>
            <div className="py-1">Hình ảnh:</div>
          </div>
          <div
            className="max-w-[1100px] h-[600px] w-full m-auto py-3 px-4 relative group text-xl"
            onMouseEnter={() => {
              setAutoPlay(false);
            }}
            onMouseLeave={() => {
              setAutoPlay(true);
            }}
          >
            <div
              style={{ backgroundImage: `url(${post?.image})` }}
              className="w-full h-full rounded-2xl bg-center bg-cover duration-500 shadow-2xl"
            >
              {/* <div className="flex items-center justify-center w-full h-full rounded-2xl bg-black bg-opacity-50">
            <h1 className="text-white text-6xl animate-pulse">
              Discover A Memorable Motel
            </h1>
          </div> */}
            </div>
            {/* <div className="hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] left-5 text-2xl rounded-full p-2 bg-black/20 text-white cursor-pointer">
              <BsChevronCompactLeft onClick={prevSlide} size={30} />
            </div>
            <div className="hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] right-5 text-2xl rounded-full p-2 bg-black/20 text-white cursor-pointer">
              <BsChevronCompactRight onClick={nextSlide} size={30} />
            </div> */}
            {/* <div className="flex top-4 justify-center py-2">
              {slides?.image.map((slide, slideIndex) => (
                <div
                  key={slideIndex}
                  onClick={() => goToSlide(slideIndex)}
                  className={`text-2xl cursor-pointer ${
                    currentIndex === slideIndex
                      ? "text-blue-500"
                      : "text-gray-500"
                  }`}
                >
                  <RxDotFilled />
                </div>
              ))}
            </div> */}
            <p className="pt-5 pb-3">Giá tiền: {post?.price}triệu/ tháng</p>
            <p className="pb-3">Địa chỉ: {post?.address}</p>
            <div className="flex pb-3">
              Nội thất:
              <div className="flex gap-2 justify-center items-center ml-5 me-3 pe-3">
                {post?.beds} <FaBed />
              </div>
              <div className="flex gap-2 justify-center items-center ml-5 me-3 pe-3">
                {post?.baths} <FaBath className="text-primary" />
              </div>
              <div className="flex gap-2 justify-center items-center ml-5 me-3 pe-3">
                {post?.wifi === 1 ? (<span>Có</span>) : (<span>Không</span>)}<FaWifi className="text-primary" />
              </div>
            </div>
            <div className="pb-3">
              <p>Mô tả: {post?.description}</p>
            </div>
            <div className="pb-3">
              <p className="pb-3">Diện tích: {post?.area} m²</p>
              <p>Số người: {post?.numberOfPeople} người</p>
            </div>
            <div className="flex justify-content-between pb-5">
              {/* <a className="btn btn-sm btn-primary rounded py-2 px-4" href="postdetails.html">View Detail</a> */}
              <button onClick={() => getProfile(post?.userId)} className="rounded py-2 px-4 bg-black text-white font-bold hover:bg-slate-900">
                Liên hệ
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export default PostDetails;
